/* eslint-disable no-console */
import {
  Wrapper,
  MenuDowloader,
  Popup,
} from './styles';

import geoConfirm from 'services/utils/confirm';

import { DownloadAndServices } from './components/DownloadAndServices';
import { EditSymbology } from './components/EditSymbology';
import { Legend } from './components/Legend';
import { Metadata } from './components/Metadata';
import { Opacity } from './components/Opacity';

import AttributeTable from '../../../../../AttributeTable';
import LayerActionsMobile from '../LayerActionsMobile';

import Icon from '@map/components/Icons';
import CircularProgress from '@material-ui/core/CircularProgress';
/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';
import { useSnackbar } from 'notistack';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useRef permite que persista valores entre renderizações, ele pode
 * ser usado para armazenar um valor mutável que não causa uma nova
 * renderização quando atualizado e pode ser usado para acessar di-
 * retamente um elemento do DOM.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useRef, useCallback } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Swipeable } from 'react-swipeable';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import TabModal from 'views/MapView/components/TabModal';
import { useMap } from 'views/MapView/hooks';


/**
 * Funçoes da Layer (codigo precisando ser refatorado)
 * 
 * Aqui estao todos os componentes do menu de ações: 
 * 
 * Enquadrar camada: enquadra a camada selecionada.
 * Ocultar rotulo: se camada possuir um rotulo é possivel oculta-lo. 
 * Metadados: um popover com informaçoes detalhadas da camada, e com um link de onde vem as informações.
 * Tabela de atributos: uma tabela de uma camada especifica com informaçoes dealhadas sobre a mesma
 * Legenda: diz qual cor,forma ou figura foi setada naquela camada.
 * Transparencia: é possivel aumentar e diminuir a transparencia da camada especifica no mapa.
 * Dowload e serviços: é possivel fazer o dowload no formato KML ou Shapefile da camada e tambem acesso 
 * aos links de WMS e WFS.
 * Remover: Exclui a camada
 * Editar simbologia: é possivel editar de uma forma mais detalhada as cores da camada importada.
 * 
 * @param {object} appContext
 * @param {object} layer
 * @param {Number} index
 * @param {function} setMenuActionActived
 * @param {*} menuActionActived
 * @returns 
 */
export const LayerItem = ({
  appContext,
  layer,
  index,
  setMenuActionActived,
  menuActionActived,
}) => {
  const [showRightOptions, setShowRightOptions] = useState(false);
  const [deltaX, setDeltaX] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const popOverRef = useRef(null);
  const [popoverView, setPopoverView] = useState(null);
  const [popOverOpen, setPopOverOpen] = useState(false);  
  const [popOverOpacityOpen, setPopOverOpacityOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [modalEditSymbology, setModalEditSymbology] = useState(false);    
  const [boundingEleItemLayer, setBoundingEleItemLayer] = useState(null);  
  const [menuOutViewport, setMenuOutViewport] = useState(false);
  const [highlight, setHighlight] = useState(false);

  const [layerStatus, setLayerStatus] = useState('loading'); // loading, loaded, error
  const [loadedBoundingBox, setLoadedBoundingBox] = useState(false);
  const [canDownload, setCanDownload] = useState(false);
  const [canShowLinkService, setCanShowLinkService] = useState(false);
  const [disabledWFS, setDisabledWFS] = useState(false);
  const [hasManualLinkDownload, setHasManualLinkDownload] = useState(false);
  const [hasMetadata, setHasMetadata] = useState(false);
  const [tableId, setTableId] = useState(null);
  
  const { enqueueSnackbar } = useSnackbar();
  
  const {
    map,
    hideLayer,
    configureVisibilityLabel,
    showLayer,
    setVisibilityLayer,
    removeLayer,
    setLayers,
    layers,
    removeClonedHighlightLayer,
  } = useMap();

  // Listeners da Inicialização da layer
  useEffect(() => {    
    if (layer.layerStatus !== 'loading') {
      setLayerStatus(layer.layerStatus);
    } else {
      const onLoadLayer = () => setLayerStatus('loaded');
      const onLoadLayerError = () => setLayerStatus('error');

      layer.addEventListener('load-layer', onLoadLayer);
      layer.addEventListener('load-layer-fail', onLoadLayerError);

      return () => {
        layer.removeEventListener('load-layer', onLoadLayer);
        layer.removeEventListener('load-layer-fail', onLoadLayerError);
      };
    }
  }, [layer]);

  // Configurações básicas da camada
  useEffect(() => {
    // Obtenção dos metadados
    if (layer.getMetadataXmlLink()) {
      setHasMetadata(true);      
      layer
        .loadMetadata()
        .catch((error) => setHasMetadata(false));
    } else {
      setHasMetadata(false);
    }

    // Obtenção do BoundingBox
    layer
      .loadBoundingBox()
      .then((bbox) => bbox && setLoadedBoundingBox(true))
      .catch((error) => setLoadedBoundingBox(false));

    // Verificação da permissão de download
    setCanDownload(layer.canDownload());
    // Verificação dos links de serviço
    setCanShowLinkService(layer.canShowLinkService());
    // Verifica se foi setado link manual de download da camada
    setHasManualLinkDownload(layer.hasManualLinkDownload());
  }, [layer]);

  /**
   * Destaque de 5 segundos quando a layer for criada
   */
  useEffect(() => {
    if (layer.type === 'criada') {
      setHighlight(true);
      setTimeout(() => setHighlight(false), 1500);
    }
  }, [layer.type]);

  /** Verifica se a tabela de atributos ainda está aberta */
  useEffect(() => {
    if (
      appContext.bottomPanelId &&
      tableId &&
      appContext.bottomPanelId !== tableId
    ) {
      setTableId(null);
    }
  }, [appContext.bottomPanelId, tableId]);

  /* Ao ocultar uma camada fechar o menu de açoes e tabela de atributos */
  useEffect(() => {
    if(layer.visible === false){
      if(menuActionActived === layer.id){
        setMenuActionActived(false)             
      }
      if(appContext.bottomPanelId === tableId){
        appContext.setBottomPanelIsOpen(false)              
      }
      
      layer.isSelected = false
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layer.visible])

   /**
   * Quando menu de ações aberto
   */
   useEffect(() => {
    if (menuActionActived && menuActionActived === layer.id) {      
      let elItemLayer = document.getElementById(menuActionActived);
      let bounding = elItemLayer.getBoundingClientRect();
      setBoundingEleItemLayer(bounding);      
      let elMenuItemLayer = elItemLayer.nextSibling;
      // Verifica se parte inferior do menu de ações ultrapassa tela.
      // Cálculo: 
      // Distância do topo da tela até parte superior do elemento layer +
      // Altura da menu de ações >
      // Atura obtida da tela
      if ((bounding.top + elMenuItemLayer.clientHeight) > (window.innerHeight || document.documentElement.clientHeight)) {
        setMenuOutViewport(true);
      } else {
        setMenuOutViewport(false);
      }
    }
  }, [menuActionActived, layer.id]);



  /**
   * Verifica se o WFS esta desabilitado
   */
  useEffect(() => {
    if(layer.layerType === 'featureType' && layer.properties.disabledServices?.string){
      let services = layer.properties.disabledServices?.string
      if(services.includes('WFS')){
        setDisabledWFS(true)
      }
    }
  }, [layer.layerType, layer.properties?.disabledServices?.string]) 

  /**
   * Método para abertura do PopOver
   */
  const handleClickPopOver = (view) => (event) => {
    if (view) {      
      let currentTarget = event.currentTarget;    
      highlightActiveButton(currentTarget);
      setAnchorEl(currentTarget);
      setPopoverView(view);
      setPopOverOpen(true);      
    }
  };

  /**
     * Método para abertura do PopOver
     */
  const handleClickPopOverOpacity = (event) => {
    let currentTarget = event.currentTarget;    
    highlightActiveButton(currentTarget);
    setAnchorEl(currentTarget);
    setPopOverOpacityOpen(true);
  }; 

  /**
   * Método para abertura do PopOver de Menu
   */
  const handleClicMenu = (event) => {
    let currentTarget = event.currentTarget;    
    highlightActiveButton(currentTarget);
    setAnchorEl(currentTarget);
    setMenuOpen(true);
  };

  /**
   * Método para fechar o PopOver, ou Menu
   */  
  const handleClosePopOver = useCallback(() => {
    removeHighlightActiveButton(anchorEl);
    setAnchorEl(null);
    popOverOpen && setPopOverOpen(false);
    popOverOpacityOpen && setPopOverOpacityOpen(false);
    menuOpen && setMenuOpen(false);    
  }, [anchorEl, popOverOpen, popOverOpacityOpen, menuOpen]);

  /**
   * Aplica efeito de botão acionado
   */
  const highlightActiveButton = (currentTarget) => {
    currentTarget.setAttribute('style', 'color:#3c71dd; background:#ffffff;');    
  };

  /**
   * Remove efeito de botão acionado
   */
  const removeHighlightActiveButton = (currentTarget) => {
    if (currentTarget) currentTarget.removeAttribute('style');       
  };

  /**
   * Ao fechar menu de ações, fehca também seus submenus.
   * Isso deve ocorrer pois o posicionamento do menu
   * é perdido. A solução encontrada foi fecha-lo quando
   * há movimentação na lista de camadas.
   * (Ex: carregamento de camada importada)
   */
  useEffect(() => {
    if (!menuActionActived) {
      handleClosePopOver();
    }
  }, [menuActionActived, handleClosePopOver]);

  useEffect(() => {    
    // Quando fechar tabela de atributos
    // e a camada estiver visível, 
    // reseta as feições da camada
    if(!appContext.bottomPanelIsOpen && layer.visible && layer.leafletLayer) {      
      layer.leafletLayer.remove();
      layer.loadLayer(map);
    }
  }, [appContext.bottomPanelIsOpen, layer, map]);

  /**
   * Método para ocultar/exibir uma camada
   */
  const toogleVisibility = (e) => {
    e.stopPropagation();
    if (layer.visible) {
      hideLayer(layer.id);
    } else {
      showLayer(layer.id);
    }
  };

  /**
   * Método usado para realizar o enquadramento da camada no mapa
   */
  const fitBounds = (e) => {
    map.flyToBounds([
      [layer.getBoundingBox().maxy, layer.getBoundingBox().maxx],
      [layer.getBoundingBox().miny, layer.getBoundingBox().minx],
    ]);
  };

  /**
   * Abertura de mensagem de confirmação
   * da exclusão da camada
   */
  const openPopupConfirmRemove = (e) => {    
    geoConfirm({
      message: 'Deseja excluir a camada?',
      callback: (confirmed) => {
        confirmed && removeThisLayer(e);
      },
    });    
  };

  /**
   * Método que realiza a exclusão da camada do mapa, e remove os listeners
   * atrelados a mesma
   *
   * @param {Event} e
   */
  const removeThisLayer = (e) => {
    // Fecha a tabela de atributos
    // if (
    //   appContext.bottomPanelId &&
    //   tableId &&
    //   appContext.bottomPanelId === tableId
    // ) {
    //   appContext.setBottomPanelIsOpen(false);
    //   setTableId(null);
    // }    
    setVisibilityLayer(layer.id, false);
    
    appContext.setBottomPanelIsOpen(false);    
    setTableId(null);

    // Remove a camada clone de destaque de feições selecionadas de camada 'interna'
    removeClonedHighlightLayer(layer);
    // Remove a layer do mapa
    removeLayer(layer.id);    
    enqueueSnackbar({ message: 'Camada excluída', variant: 'success' });
  };

  /**
   * Abre modal formulário de edição de simbologia por atributo
   *
   * @param {Event} e
   */
  const handleModalEditSymbology = (e) => {
    setModalEditSymbology(!modalEditSymbology);
  };

  const views = [
    {
      title: 'Editar Simbologia',
      Component: (
          <EditSymbology           
          open={modalEditSymbology}          
          onClose={(type) => {
            if (type !== 'clickAway') {
              setModalEditSymbology(!modalEditSymbology);
            }            
          }}          
            layer={layer}   
            modalEditSymbology={modalEditSymbology}  
            setModalEditSymbology={setModalEditSymbology}      
          />
      ),
      valid: true,
    },
  ];
  //metódo para obter descrição especifica do hint dependendo da tipologia da camada
  const getHint = (layer) => {
    if(layer.type === "criada"){
      return "Criada pelo usuário"
    }
    else if(layer.type === "importada" || layer.type === "importada-raster" || (layer.type === "externa" && layer.externalServiceId === null)){
      return "Adicionada pelo usuário"
    }
    else{
      return "Disponibilizada pelo Geobahia"
    }
  }
  //metódo para obter tipo da camada
  const getTypeLayer = (layer) => {
    if((layer.type === "interna") || (layer.type === "externa" && layer.externalServiceId !== null)){
      return "Geobahia"
    }
    else if((layer.type === "importada")||(layer.type === "importada-raster")||(layer.type === "externa" && layer.externalServiceId === null)){
      return "Importada"
    }
    else if(layer.type === "criada"){
      return "Criada"
    }
  }
  //metódo para obter descrição dos dados da camada
  const getDescriptionLayer = (layer) => {
    if(layer.type === "criada"){
      if(layer.dataType === "LineString"){
        return "linha"
      }
      else if(layer.dataType === "Point"){
        // let childLayer = layer.leafletLayer.getLayers()[0];         
        // return childLayer.pm.textArea
        //         ? 'texto'
        //         : 'ponto'
        return "ponto" 
      }
      else if(layer.dataType === "Text"){
        return "texto" 
      }
      else{
        return "polígono";
      }
    }
    if(layer.type === "interna"){
      if(layer.dataType !== "Raster"){
        return layer.additionalProps.service;
      }
      else{
        return layer.dataType;
      }
    }
    if(layer.type === "importada" || layer.type === "importada-raster"){
      if(layer.dataType === "Raster"){
        return "raster";
      }
      else{
        if(layer.fileType === "zip"){
          return "shape"

        }else{
          return layer.fileType

        }
      }
    }
    if(layer.type === "externa")
     if(layer.externalServiceId !== null){
      return "externa"
    }else{
      return "geoserviço"
    }

  }

  const handleOnClick = async (e, layer, menuActionActived, setMenuActionActived, appContext, map) => {
    e.stopPropagation();
  
    if (window.innerWidth > 768) {
      menuActionActived === layer.id
        ? setMenuActionActived(null)
        : setMenuActionActived(layer.id);
    } else {
      setMenuActionActived(false);
      const views = [
        {
          title: 'Legenda',
          Component: Legend,
          valid: true,
        },
        {
          title: 'Metadados',
          Component: Metadata,
          valid: true,
        },
        {
          title: 'Atributo',
          Component: AttributeTable,
          props: {
            layer: layer,
            map: map,
          },
          valid: true,
        },
      ];
      appContext.setBottomPanelIsOpen(
        !appContext.bottomPanelIsOpen,
        layer.getTitle(),
        !appContext.bottomPanelIsOpen && (
          <LayerActionsMobile views={views} />
        )
      );
    }
  };

  useEffect(() => {
    if (appContext.bottomPanelIsOpen) {
      setMenuActionActived(false);
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  , [appContext.bottomPanelIsOpen]);
  
  return (
    <Swipeable
      onSwipedLeft={() => setShowRightOptions(true)}
      onSwipedRight={() => setShowRightOptions(false)}
      onSwiping={(e) => {
        // Caso steja deslizando para a esquerda
        if (e.dir === 'Left' && !showRightOptions) {
          setDeltaX(e.absX);
        }
      }}
      onSwiped={(e) => {
        setDeltaX(0);
      }}
    >
      <Draggable key={layer.id} draggableId={`${layer.id}`} index={index}>
        {(provided, snapshot) => {
          if (snapshot.isDragging) {
            setDeltaX(0);
            setShowRightOptions(false);
          }
          return (
            <Wrapper
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              showRightOptions={showRightOptions}
              // heightEl={document.getElementById(layer.id)?.offsetHeight}
              heightEl={boundingEleItemLayer?.height}
              // boundingTop={document.getElementById(layer.id)?.getBoundingClientRect().top}
              boundingTop={boundingEleItemLayer?.top}
              menuOutViewport={menuOutViewport} // serve 
            >
              <div
              
                id={layer.id}
                className={`layer-item ${
                  (snapshot.isDragging || layer.isSelected || highlight) &&
                  'active'
                }`}
                style={
                  deltaX !== 0
                    ? {
                        transform: `translateX(-${deltaX}px)`,
                      }
                    : null
                }
                onClick={() => {
                  if(layer.visible !== false) { layer.setSelected(!layer.isSelected) }
                  setLayers([...layers]);
                }}
              >
                <div
                  className="right-swipeable-option"
                  style={
                    deltaX !== 0
                      ? {
                          transform: `translateX(${deltaX}px)`,
                        }
                      : null
                  }
                >
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      removeThisLayer();
                    }}
                  >
                    <Icon i="map-trash" />
                  </button>
                </div>
                <div className="left-addorn">
                  {layerStatus === 'loading' && (
                    <CircularProgress size="15px" />
                  )}
                  {layerStatus === 'loaded' && (
                    <Tooltip
                      title={`${layer.visible ? 'Ocultar' : 'Exibir'} camada`}
                      placement="bottom"
                    >
                      <button
                        onClick={toogleVisibility}
                        className={`${layer.visible ? '' : 'disabled'}`}
                      >
                        {layer.visible ? (
                          <Icon i="map-eye" />
                        ) : (
                          <Icon i="map-closedeye" />
                        )}
                      </button>
                    </Tooltip>
                  )}
                </div>

                {/* Nome da camada */}
                <h3
                  className={`layer-content ${layer.visible ? '' : 'disabled'}`}
                >
                  {layer.getTitle()}
                </h3>

                {/* identificação da camada */}
                <Tooltip title={getHint(layer)} placement="bottom" className={`${layer.visible ? '' : 'tooltipDisabled'}`} disabled={layer.visible ? false : true}>
                  <h5 className="identification">
                    {getTypeLayer(layer)} - {getDescriptionLayer(layer)}
                  </h5>
                </Tooltip>

                <div
                  className={`right-addorn ${layer.visible ? '' : 'disabled'}`}
                >
                  {layerStatus === 'loaded' && (
                    <div>                      
                      <Tooltip title="Ações" placement="bottom" className={`${layer.visible ? '' : 'tooltipDisabled'}`}>
                        <button
                          onClick={async (e) => {handleOnClick(
                            e,
                            layer,
                            menuActionActived,
                            setMenuActionActived,
                            appContext,
                            map
                          )}}
                          className={`${layer.visible ? '' : 'disabled'}`}
                          disabled={layer.visible ? false : true}
                        >
                          <Icon i="map-controllers" />
                        </button>
                      </Tooltip>
                    </div>
                  )}
                </div>
              </div>
              <div
                className={`layer-actions ${
                  menuActionActived === layer.id && 'active'
                }`}
              >
                <Tooltip title="Enquadrar camada" placement="bottom">
                  <button
                    className={`layer-action ${ !loadedBoundingBox && 'disabled cursorDefault' }`}
                    onClick={(e) => loadedBoundingBox && fitBounds(e)}
                  >
                    <Icon i="map-fit" fill={!loadedBoundingBox && '#B6B6B6'} />
                  </button>
                </Tooltip>
                <Tooltip
                  title={`${
                    layer.statusLabelVisibility ? 'Ocultar' : 'Exibir'
                  } rótulo`}
                  placement="bottom"
                >
                  <button
                    className={`layer-action 
                      ${(!layer.selectedLabelColumn || layer.dataType === 'Text') && 
                        'disabled cursorDefault'}
                    `}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (layer.selectedLabelColumn && 
                        layer.visible && 
                        layer.dataType !== 'Text') {
                          configureVisibilityLabel(layer.id);
                      }
                    }}
                  >
                    {layer.selectedLabelColumn && layer.visible && layer.dataType !== 'Text' ? (
                      layer.statusLabelVisibility ? (
                        <Icon i="map-configureLabelClose" />
                      ) : (
                        <Icon i="map-configureLabel" />
                      )
                    ) : (
                      <Icon i="map-configureLabelClose" fill="#B6B6B6" />
                    )}
                  </button>
                </Tooltip>
                <Tooltip title="Metadados" placement="bottom">
                  <button
                    className={`layer-action ${!hasMetadata && 'disabled cursorDefault'}`}
                    onClick={hasMetadata && handleClickPopOver('metadata')}
                  >
                    <Icon i="map-tag" fill={!hasMetadata && '#B6B6B6'} />
                  </button>
                </Tooltip>
                <Tooltip title="Tabela de atributos" placement="bottom">
                  <button
                    className={`layer-action ${
                      (layer.type === 'externa' || layer.type === 'importada-raster' || disabledWFS) && 'disabled cursorDefault'
                    } ${
                      tableId &&
                      'layer-action-active'
                    } ${
                      tableId && 
                      !popOverOpen && 
                      !popOverOpacityOpen &&
                      !menuOpen &&
                      !modalEditSymbology
                    }`}                    
                    onClick={() => {                         
                      if (layer.type === 'externa' || layer.type === 'importada-raster' || layer.dataType === 'Raster' || disabledWFS) return;                      
                      if (!tableId) {
                        const panelId = appContext.setBottomPanelIsOpen(
                          true,
                          layer.getTitle(),
                          <AttributeTable
                            layer={layer}
                            map={map}
                            removeThisLayer={removeThisLayer}
                          />
                        );
                        setTableId(panelId);
                      } else {                        
                        appContext.setBottomPanelIsOpen(false);
                        setTableId(null);
                      }
                    }}
                  >
                    <Icon
                      i="map-table"                      
                      {...(layer.type === 'externa' || layer.type === 'importada-raster' || layer.dataType === 'Raster' || disabledWFS
                        ? {fill: '#B6B6B6'}
                        : {})
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip title="Legenda" placement="bottom">
                  <button
                    className={`layer-action ${
                      (!(!layer.getService() ||
                        layer.getService() === 'WMS' ||
                        layer.type === 'criada' ||
                        layer.type === 'importada') ||
                        layer.dataType === 'Text') &&
                      'disabled cursorDefault'
                    }`}
                    onClick={
                      (!layer.getService() ||
                      layer.getService() === 'WMS' ||
                      layer.type === 'criada' ||
                      layer.type === 'importada') &&
                      layer.dataType !== 'Text' &&
                      handleClickPopOver('legend')
                    }
                  >
                    <Icon
                      i="map-legend"
                      fill={
                        (!layer.getService() ||
                        layer.getService() === 'WMS' ||
                        layer.type === 'criada' ||
                        layer.type === 'importada') &&
                        layer.dataType !== 'Text'
                          ? null
                          : '#B6B6B6'
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip title="Transparência" placement="bottom">
                    <button                      
                      className={`layer-action 
                        ${layer.dataType === 'Text' && 
                          'cursorDefault'
                        }`
                      }
                      onClick={layer.dataType !== 'Text' && handleClickPopOverOpacity}            
                    >
                      <Icon
                        i="map-opacity" 
                        {...(layer.dataType === 'Text'
                              ? {
                                  fill: '#B6B6B6',                                  
                                }
                              : {})
                        }
                      />
                    </button>
                </Tooltip>
                <Popup
                  anchorEl={anchorEl}
                  open={popOverOpacityOpen}
                  onClose={handleClosePopOver}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 36,
                    horizontal: 0,
                  }}               
                  minWidth={'220px'}                    
                >
                  <Opacity 
                    layerId={layer.id} 
                    leafletLayer={layer.leafletLayer}
                    opacity={layer.layerStyle.opacity}
                    fillOpacity={layer.layerStyle.fillOpacity}
                    type={layer.type}
                    dataType={layer.dataType}
                    service = {layer.additionalProps?.service}
                  />
                </Popup>
                <Tooltip
                  title={
                    (canDownload || canShowLinkService) &&
                    (layer.type === 'interna' || layer.type === 'criada' || layer.type === 'importada')
                      ? 'Download e Serviços'
                      : 'Dados indisponíveis'
                  }
                  placement="bottom"
                >
                  <button
                    className={`layer-action ${
                      !canDownload &&
                      (!canShowLinkService || layer.type !== 'interna') &&
                      'disabled cursorDefault'
                    }`}
                    onClick={(e) =>
                      (canDownload || canShowLinkService) &&
                      (layer.type === 'interna' || layer.type === 'criada' || layer.type === 'importada') &&
                      handleClicMenu(e)
                    }
                  >
                    <Icon
                      i="map-downloadandgeoservices"
                      className={`${
                        !canDownload &&
                        (!canShowLinkService || layer.type !== 'interna') &&
                        'disabled'
                      }`}
                    />
                  </button>
                </Tooltip>
                <Tooltip title="Editar simbologia" placement="bottom">
                  <button
                    className={`layer-action 
                      ${
                        modalEditSymbology &&
                        'layer-action-active layer-action-current-active'                      
                      } 
                      ${(((layer.type === "interna" || layer.type === "externa") && 
                        layer.additionalProps?.service !== "WFS" ) ||
                        layer.dataType === 'Text') && 
                        'cursorDefault'
                      }`
                    }
                    onClick={() => 
                      (layer.type === 'importada' || layer.type === 'criada' || ((layer.type === "interna" || layer.type === "externa") && 
                      layer.additionalProps?.service === "WFS" )) && 
                      layer.dataType !== 'Text' &&
                      handleModalEditSymbology()
                    }
                  >
                    <Icon
                      i="map-editSymbology"
                      fill={`${
                        (layer.type === 'importada' || layer.type === 'criada' || ((layer.type === "interna" || layer.type === "externa") && 
                        layer.additionalProps?.service === "WFS" )) && 
                        layer.dataType !== 'Text'
                          ? ''
                          : '#b6b6b6'
                      }`}
                    />
                  </button>

                </Tooltip>
                <Tooltip title="Remover" placement="bottom">
                  <button className="layer-action" onClick={openPopupConfirmRemove}>
                    <Icon i="map-trash" />
                  </button>
                </Tooltip>
              </div>
              <Popup
                anchorEl={anchorEl}
                open={popOverOpen}
                onClose={handleClosePopOver}
                anchorOrigin={{
                  vertical: 'center',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 46,
                  horizontal: 0,
                }}
                ref={popOverRef}
                padding={'25px 30px'} 
                minWidth={'250px'}
              >
                {popoverView === 'legend' &&                   
                    <Legend
                      layer={layer}
                      map={map} 
                      handleClosePopOver={handleClosePopOver}                 
                    />                  
                }
                {popoverView === 'metadata' && 
                    <Metadata
                      layer={layer}
                      handleClosePopOver={handleClosePopOver}
                      canShowLinkService={canShowLinkService}
                      hasMetadata={hasMetadata}
                    />
                }
              </Popup>             
              <MenuDowloader
                id="download-format-select"
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleClosePopOver}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 30,
                  horizontal: 0,
                }}
              >           
                <DownloadAndServices
                  layer={layer}
                  canDownload={canDownload} 
                  hasManualLinkDownload={hasManualLinkDownload}                  
                  handleClosePopOver={handleClosePopOver}
                />                   
              </MenuDowloader>
            </Wrapper>
          );
        }}
      </Draggable>
      <TabModal        
        open={modalEditSymbology}
        onClose={() => { setModalEditSymbology(!modalEditSymbology);}}
        views={views}
        sectionWidth={420}
        sectionHeight={660}      
      /> 
    </Swipeable>
  );
};

export default LayerItem;
